export const MiddlewareEntities = {
  PAGE_SHELL: '[PAGE_SHELL]',
  PAGE_DATA: '[PAGE_DATA]',
  PAGE_DATA_DEVICE_LIST: '[PAGE_DATA_DEVICE_LIST]',
  PAGE_DATA_DEVICE_OVERVIEW: '[PAGE_DATA_DEVICE_OVERVIEW]',
  UI: '[UI]',
  PRODUCTS: '[PRODUCTS]',
  PRODUCT: '[PRODUCT]',
  PRODUCT_INSURANCE: '[PRODUCT_INSURANCE]',
  PRODUCT_SUGGESTIONS: '[PRODUCT_SUGGESTIONS]',
  NOTIFICATION: '[NOTIFICATION]',
  USER_MESSAGE: '[USER_MESSAGE]',
  SECTION: '[SECTION]',
  LANGUAGE: '[LANGUAGE]',
  SITE_HEADER: '[SITE_HEADER]',
  FILTERS_LIST: '[FILTERS_LIST]',
  SEARCH_PARAMS: '[SEARCH_PARAMS]',
  // SESSION
  SESSION_DATA: '[SESSION_DATA]',
  WS_USER_INFO: '[WS_USER_INFO]',
  CAPTCHA: '[CAPTCHA]',
  STORES_MAP: '[STORES_MAP]',
  STORES_MAP_CLOSEST: '[STORES_MAP_CLOSEST]',
  STORES_MAP_MULTIPLE: '[STORES_MAP_MULTIPLE]',
  AVAILABILITY_PRODUCT: '[AVAILABILITY_PRODUCT]',
  // CONTRACT
  CONTRACT: {
    MANHATTAN: '[MANHATTAN_CONTRACT]',
  },
  // ORDER
  ORDER: {
    BASIC_ORDER: '[ORDER]',
    ORDER_SUBMIT: '[ORDER_SUBMIT]',
    ACCESSORIES_ORDER_SUBMIT: '[ACCESSORIES_ORDER_SUBMIT]',
    ORDER_CANCEL: '[ORDER_CANCEL]',
    SEND_VERIFICATION_SMS: '[SEND_VERIFICATION_SMS]',
    SEND_VERIFICATION_CODE: '[SEND_VERIFICATION_CODE]',
    MANHATTAN_SUBMIT: '[MANHATTAN_SUBMIT]',
    MANHATTAN_PURCHASE_FTTH_SUBMIT: '[MANHATTAN_PURCHASE_FTTH_SUBMIT]',
    MANHATTAN_CANCEL: '[MANHATTAN_CANCEL]',
    MANHATTAN: {
      ORDER: '[MANHATTAN_ORDER]',
      FTTH_ORDER: '[FTTH_ORDER]',
      NEXT_ORDER_DATA_STEP: '[NEXT_ORDER_DATA_STEP]',
      PREVIOUS_ORDER_DATA_STEP: '[PREVIOUS_ORDER_DATA_STEP]',
      SEND_ORDER_TO_EMAIL: '[SEND_ORDER_TO_EMAIL]'
    },
    SEND_VOUCHER_FOR_VERIFICATION: '[TELCO_SEND_VOUCHER_FOR_VERIFICATION]',
    TELCO: {
      ORDER: '[TELCO ORDER]',
    },
    ACCESSORY: {
      ORDER: '[ACCESSORY ORDER]',
    },
    GREEN_VOUCHER: {
      SEND_VOUCHER_FOR_VERIFICATION: '[SEND_GREEN_VOUCHER_FOR_VERIFICATION]',
      SET_VOUCHER_APPLIED: '[SET_VOUCHER_APPLIED]',
      SET_VOUCHER_FAILED_MESSAGE: '[SET_VOUCHER_FAILED_MESSAGE]',
      SET_DEVICE_NUMBER_SPECIFIED: '[SET_DEVICE_NUMBER_SPECIFIED]',
      CLEAR_APPLIED_VOUCHER: '[CLEAR_APPLIED_VOUCHER]',
    },
    CHANGE_DEVICE_COLOR: '[CHANGE_DEVICE_COLOR]',
    REMOVE_ITEM_FROM_BASKET: '[REMOVE_ITEM_FROM_BASKET]',
    PREPARE_BASKET_ITEM_FOR_REPLACEMENT: '[PREPARE_BASKET_ITEM_FOR_REPLACEMENT]'
  },
  TRANSACTION: '[TRANSACTION]',
  CANCEL_TRANSACTION: '[CANCEL_TRANSACTION]',
  CANCEL_P2P_TRANSACTION: '[CANCEL_P2P_TRANSACTION]',
  MANHATTAN: {
    FTTH: {
      ADDITIONAL_DEVICES: '[ADDITIONAL_DEVICES]',
      SINGLE_PRODUCT: '[SINGLE_PRODUCT]',
      FTTH_PRODUCT: '[FTTH_PRODUCT]',
    },
    POST_OTT: {
      SINGLE_PRODUCT: '[SINGLE_PRODUCT_POST_OTT]',
    },
    OTT: {
      OTT_PRODUCT: '[OTT_PRODUCT]',
    },
    BUNDLE: '[BUNDLE]'
  },
  CAMPAIGN: {
    ALL: '[CAMPAIGN]',
    OVERVIEW_DATA: '[OVERVIEW_DATA]',
    OVERVIEW_CSS: '[OVERVIEW_CSS]',
    CONSENT: '[CONSENT]',
    ACCEPTANCE: {
      ALL: '[ACCEPTANCE]',
      STATUS: '[ACCEPTANCE_STATUS]',
      SEND_ACCEPTANCE_REQUEST: '[SEND_ACCEPTANCE_REQUEST]'
    },
    DETAILS: '[DETAILS]',
    SUBMIT: '[CAMPAIGN_SUBMIT]',
    SOFT_ELECTRO: '[CAMPAIGN_SOFT_ELECTRO]',
    RESEND_OFFER: '[CAMPAIGN_RESEND_OFFER]',
    CANCEL_OFFER: '[CAMPAIGN_CANCEL_OFFER]',
    SEND_NEW_OFFER: '[CAMPAIGN_SEND_NEW_OFFER]',
    MODE: '[CAMPAIGN_MODE]',
    SUBMIT_EANEX: '[SUBMIT_EANEX]',
    CAMPAIGN_HELP: '[CAMPAIGN_HELP]'
  },
  PAK: {
    PAK_CITY: '[PAK_CITY]',
    PAK_NEIGHBORHOOD: '[PAK_NEIGHBORHOOD]',
    PAK_STREET: '[PAK_STREET]',
  },
  COMPARE: {
    MAIN: '[COMPARE_DEVICES]',
  },
  WISH_LIST: {
    PRODUCTS: '[WISH_LIST_PRODUCTS]',
    CHANGE: '[WISH_LIST_CHANGE]',
    CHANGE_SUCCESS: '[WISH_LIST_CHANGE_SUSSESS]',
    CHANGE_ERROR: '[WISH_LIST_CHANGE_ERROR]',
    SAVE_PRODUCT: '[WISH_LIST_SAVE_PRODUCT]',
  },
  AUTH: {
    LOGIN: '[LOGIN]',
    LOGOUT: '[LOGOUT]',
    LOGOUT_BFF: '[LOGOUT_BFF]',
    SSO: '[SSO]',
    SSO_TEST: '[SSO_TEST]',
    SSO_TEST_DATA: '[SSO_TEST_DATA]',
    SSO_REDIRECT: '[SSO_REDIRECT]'
  },
  COOKIE: {
    COMPARE_COOKIE_TOKEN: '[COMPARE_COOKIE_TOKEN]',
    SET_SHOULD_CALL_LOGIN: '[SET_SHOULD_CALL_LOGIN]',
  },
  ANALYTICS: '[ANALYTICS]',
  DEBUG: `[DEBUG]`
};

export default MiddlewareEntities;
